import { STORAGE_ORDER } from '@blocks/constants';
import { useOrderStore } from '@blocks/stores/order';
import getDefaultStorage from '@blocks/utils/getDefaultStorage';

import { scrollTo } from '../utils';

/**
 * @param {Object} args
 * @param {String} [args.domain]
 * @param {Boolean} [args.scroll]
 * @param {number} [args.threshold] - scroll threshold (padding-top)
 * @param {String} [args.paper_type]
 * @param {Number} [args.pages_qty]
 * @param {Number} [args.words_qty]
 * @param {Number} [args.deadline_datetime]
 * @param {String} [args.writer_req_slug]
 * @param {String} [args.title]
 *  * @param {String} [args.href]
 * @param {String} [args["paper-size-type"]]
 */
export const setOrder = ({
  domain = '/',
  scroll = true,
  threshold = 80,
  paper_type,
  pages_qty,
  words_qty,
  deadline_datetime,
  writer_req_slug,
  title,
  href = '/registration.html',
  ...rest
}) => {
  /**
   * @TODO multiple forms (use domain + data attr as unique id)
   */
  const scrollTarget =
    document.querySelector('[data-bb="login"]') || document.querySelector('[data-bb="paper_type"]');

  const args = {
    domain,
    paper_type,
    pages_qty,
    words_qty,
    deadline_datetime,
    writer_req_slug,
    title,
    'paper-size-type': rest['paper-size-type'],
  };

  const fields = Object.keys(args).reduce(
    (acc, key) => (args[key] ? { ...acc, [key]: args[key] } : acc),
    {},
  );

  useOrderStore.getState().setOrderAction(fields);

  if (scroll && scrollTarget) {
    scrollTo(scrollTarget, { cb: () => scrollTarget.focus(), threshold });
  } else {
    window.location.href = href;
  }
};

/**
 * @param {Object} args
 * @param {String} [args.paper_type]
 * @param {Number} [args.pages_qty]
 * @param {Number} [args.words_qty]
 * @param {Number} [args.deadline_datetime]
 * @param {String} [args.writer_req_slug]
 * @param {String} [args.title]
 * @param {String} [args["paper-size-type"]]
 */
export const setOrderInitial = ({
  paper_type,
  pages_qty,
  words_qty,
  deadline_datetime,
  writer_req_slug,
  title,
  ...rest
}) => {
  const args = {
    paper_type,
    pages_qty,
    words_qty,
    deadline_datetime,
    writer_req_slug,
    title,
    'paper-size-type': rest['paper-size-type'],
  };

  const initial = Object.keys(args).reduce(
    (acc, key) => (args[key] ? { ...acc, [key]: args[key] } : acc),
    {},
  );
  const storage = getDefaultStorage();
  const prevStore = JSON.parse(storage.getItem(STORAGE_ORDER));
  storage.setItem(
    STORAGE_ORDER,
    JSON.stringify({ state: { order: { ...prevStore?.state?.order, ...initial } } }),
  );
};
